export default [
  {
    path: "/rapormusteri",
    name: "rapormusteri",
    component: () => import("./index.vue"),
    meta: {
      public: false,
      title: "rapormusteri.Baslik",
      yetki: { k: [2000902] },
    },
  },
]
